module.exports = __webpack_public_path__ + "static/media/lishi.7552702f.png";